import UserClientCard from './UserClientCard';
import { UserClientCardProps } from './UserClientCardProps';

interface Props {
  cards: UserClientCardProps[];
}

const UserClientCards: React.FC<Props> = ({ cards }) => {
  return (
    <>
      {cards.map((card, i) => (
        <UserClientCard key={card.userClientUId} cardProps={card} delay={100 + i * 40} />
      ))}
    </>
  );
};

export default UserClientCards;
